import toStringTagSupport from '../internals/to-string-tag-support.js';
import '../internals/redefine.js';
import objectToString from '../internals/object-to-string.js';
import { r as redefine$1 } from '../../../../../../_virtual/redefine.js';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine = redefine$1.exports;
var toString = objectToString; // `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring

if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, {
    unsafe: true
  });
}
